module.exports = __webpack_public_path__ + "static/media/Gotham-BookItalic.80f10f24.ttf";